<template>
  <div>
    <v-card-text>
      <v-form>
        <v-container
          v-if="availableGiveawayTypes.length"
        >
          <div
            v-for="(giveawayType, typeIndex) in availableGiveawayTypes"
            :key="`giveaway-type-${giveawayType.type}`"
          >
            <div
              v-if="!redeemedGiveaways[typeIndex]"
            >
              Choose available perk type
              <v-select
                v-model="selectedGiveawayType"
                :items="availableGiveawayTypes"
                outlined
                required
              />
              <div
                v-if="availableGiveawaySubtypes[typeIndex] && selectedGiveawayType !== ''"
              >
                Choose available perk subtype
                <v-select
                  v-if="selectedGiveawayType !== ''"
                  v-model="selectedGiveawaySubtype"
                  :items="availableGiveawaySubtypes[typeIndex]"
                  outlined
                  required
                />
              </div>
            </div>
            <div
              v-else
            >
              <p>
                <strong>
                  You've claimed <span class="giveaway-type">{{ giveawayType }}: </span>
                </strong>
              </p>
              <div v-if="redeemedGiveawayValues[typeIndex].includes('challengeCode')">
                <p>
                  Click on the link below and enter the
                  challenge code in order to get your Doordash code:<br><br>
                </p>
                <p>
                  <a
                    :href="getUrlFromGiveaway(redeemedGiveawayValues[typeIndex])"
                    target="_blank"
                    class="doordash-link"
                  >
                    {{ getUrlFromGiveaway(redeemedGiveawayValues[typeIndex]) }}
                  </a>
                </p>
                <p>
                  Challenge Code: <span class="redeemed-code">
                    {{ getChallengeCodeFromGiveaway(redeemedGiveawayValues[typeIndex]) }}
                  </span>
                </p>
              </div>
              <div
                v-else
                class="redeemed-code"
              >
                {{ redeemedGiveawayValues[typeIndex] }}
              </div>
            </div>
          </div>
        </v-container>
        <v-container
          v-else
        >
          <p>Stay tuned! Giveaways coming soon!</p>
        </v-container>
      </v-form>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-btn
        color="primary"
        text
        class="cancel-button"
        @click="closeDialog()"
      >
        Cancel
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="!haveARedeemedPerk && availableGiveawayTypes.length > 0"
        color="primary"
        text
        class="submit-button"
        @click="redeemGiveaways()"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import GiveawaysClient from '@/api/GiveawaysClient';
import { mapGetters } from 'vuex';

export default {
  name: 'GiveawaysRedeem',
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      availableGiveawayTypes: [],
      // will be array of arrays, mapping to the index of the main types
      availableGiveawaySubtypes: [],
      selectedGiveawayType: '',
      selectedGiveawaySubtype: '',
      redeemedGiveaways: [],
      redeemedGiveawayValues: [],
      haveARedeemedPerk: false,
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
    }),
  },
  mounted() {
    this.getGiveawaysData();
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
    getUrlFromGiveaway(giveawayUrl) {
      return giveawayUrl.split('?challengeCode=')[0];
    },
    getChallengeCodeFromGiveaway(giveawayUrl) {
      return giveawayUrl.split('?challengeCode=')[1];
    },
    async redeemGiveaways() {
      const eventId = this.$store.state.hackathonID || '';
      try {
        if (eventId !== '') {
          /* eslint-disable-next-line max-len */
          const giveawaysClient = new GiveawaysClient(this.currentJwtToken, eventId);
          /* eslint-disable-next-line max-len */
          await giveawaysClient.redeemGiveaway(this.selectedGiveawayType, this.selectedGiveawaySubtype);
          this.closeDialog();
          this.$router.go();
        }
      } catch (err) {
        /* eslint-disable-next-line no-alert */
        alert('Unable to redeem giveaway. Please reach out to an event admin for more information.');
      }
    },
    async getGiveawaysData() {
      // TODO create a mixin or something to stop having to repeat the following 3 lines
      const eventId = this.$store.state.hackathonID || '';
      if (eventId !== '') {
        /* eslint-disable-next-line max-len */
        const giveawaysClient = new GiveawaysClient(this.currentJwtToken, eventId);
        const responseData = await giveawaysClient.getGiveaways();
        this.availableGiveawayTypes = responseData.map((giveawayType) => giveawayType.type);
        if (responseData !== undefined) {
          responseData.forEach((giveawayType) => {
            const availableSubtypes = giveawayType.subtypes.map((subtype) => subtype.subtype);
            this.availableGiveawaySubtypes.push(availableSubtypes);
            this.redeemedGiveaways.push(giveawayType.redeemed);
            this.redeemedGiveawayValues.push(giveawayType.value);
            if (giveawayType.redeemed) {
              this.haveARedeemedPerk = true;
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.submit-button {
  text-transform: none;
  background-color: #004e7d !important;
  color: #fff !important;
}

.cancel-button {
  text-transform: none;
  color: #004e7d;
}

.giveaway-type {
  text-transform: capitalize;
}

.redeemed-code {
  padding: .5em;
  background-color: #f2f2f2;
}

.doordash-link {
  margin-bottom: 10px;
  display: block;
}
</style>
